module.exports = "<div class=\"pie-chart-item-container\">\n    <div ba-panel>\n        <div class=\"pie-chart-item\">\n            <div easypiechart class=\"chart\" options=\"$ctrl.options\" percent=\"$ctrl.percent\">\n                <span class=\"percent\">{{ $ctrl.percent }}</span>\n            </div>\n            <div class=\"description\">\n                <div>{{ $ctrl.title}}</div>\n                <div class=\"description-stats\">{{ $ctrl.description }}</div>\n            </div>\n            <em class=\"chart-icon {{ $ctrl.icon }}\"></em>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Chart/PieChart/pieChart.html
// module id = 893
// module chunks = 0